import { render, staticRenderFns } from "./TIMIRiskIndex.vue?vue&type=template&id=f3ed4eac&scoped=true&"
import script from "./TIMIRiskIndex.vue?vue&type=script&lang=js&"
export * from "./TIMIRiskIndex.vue?vue&type=script&lang=js&"
import style0 from "./TIMIRiskIndex.vue?vue&type=style&index=0&id=f3ed4eac&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3ed4eac",
  null
  
)

export default component.exports